/**
 * VersionSkeleton - Loading placeholder for version list items
 */
import { RowSkeleton, RowListSkeleton } from './Skeleton';

export function VersionSkeleton() {
  return <RowSkeleton />;
}

export function VersionListSkeleton({ count = 3 }: { count?: number }) {
  return <RowListSkeleton count={count} />;
}
